type AiAssistantIconConfig = {
	icon: string;
	darkIcon?: string;
};

export const getAiAssistantIconUri = (
	{ icon, darkIcon }: AiAssistantIconConfig,
	isDark: boolean,
) => (isDark && darkIcon ? darkIcon : icon);

export const defaultAiAssistantInfo = {
	title: "Ai Learning Agent",
	alias: "AiLA",
	icon: "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
	showOriginalQuestion: true,
	initialMessage:
		"👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
};
